import { render, staticRenderFns } from "./NotificationTemplatePanel.vue?vue&type=template&id=4d8b83d0&scoped=true"
import script from "./NotificationTemplatePanel.vue?vue&type=script&lang=js"
export * from "./NotificationTemplatePanel.vue?vue&type=script&lang=js"
import style0 from "./NotificationTemplatePanel.vue?vue&type=style&index=0&id=4d8b83d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8b83d0",
  null
  
)

export default component.exports